webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	__webpack_require__(3);
	
	var _Step = __webpack_require__(5);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _Step3 = __webpack_require__(7);
	
	var _Step4 = _interopRequireDefault(_Step3);
	
	var _Step5 = __webpack_require__(9);
	
	var _Step6 = _interopRequireDefault(_Step5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// main scss
	var pages = [{ hash: '#sand', class: _Step2.default }, { hash: '#paper', class: _Step4.default }, { hash: '#colors', class: _Step6.default }];
	// main dependencies
	
	
	var app = null;
	
	readRoute();
	
	function readRoute() {
	
	    for (var i = 0, l = pages.length; i < l; i++) {
	        var page = pages[i];
	        if (page.hash == window.location.hash) {
	            var previous = i > 0 ? pages[i - 1].hash : '';
	            var next = i < l - 1 ? pages[i + 1].hash : '';
	            setNewApp(page.class, page.hash, previous, next);
	            return;
	        }
	    }
	    // default fallback:
	    window.location.hash = pages[pages.length - 1].hash;
	    setNewApp(pages[pages.length - 1].class, pages[pages.length - 1].hash, pages[pages.length - 2].hash, '');
	}
	
	function setNewApp(Class, hash, previous, next) {
	    // console.log(' --', hash.replace('#','') );
	    app = new Class();
	    // if ( previous != '' ) {
	    //     let a = document.createElement('a');
	    //     a.setAttribute('href', 'javascript:window.updateRoute("'+previous+'");');
	    //     a.setAttribute('class','arrow-anchor left');
	    //     a.innerHTML = '<span><</span>' + previous.replace('#','');
	    //     document.body.appendChild(a);
	    // }
	    // if ( next != '' ) {
	    //     let a = document.createElement('a');
	    //     a.setAttribute('href', 'javascript:window.updateRoute("'+next+'");');
	    //     a.setAttribute('class','arrow-anchor right');
	    //     a.innerHTML = next.replace('#','') + '>';
	    //     document.body.appendChild(a);
	    // }   
	}
	
	function updateRoute(hash) {
	    window.location.hash = hash;
	    window.location.reload();
	}
	window.updateRoute = updateRoute;

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// randomColor by David Merfield under the CC0 license
	// https://github.com/davidmerfield/randomColor/
	
	;(function(root, factory) {
	
	  // Support AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Support CommonJS
	  } else if (typeof exports === 'object') {
	    var randomColor = factory();
	
	    // Support NodeJS & Component, which allow module.exports to be a function
	    if (typeof module === 'object' && module && module.exports) {
	      exports = module.exports = randomColor;
	    }
	
	    // Support CommonJS 1.1.1 spec
	    exports.randomColor = randomColor;
	
	  // Support vanilla script loading
	  } else {
	    root.randomColor = factory();
	  }
	
	}(this, function() {
	
	  // Seed to get repeatable colors
	  var seed = null;
	
	  // Shared color dictionary
	  var colorDictionary = {};
	
	  // Populate the color dictionary
	  loadColorBounds();
	
	  var randomColor = function (options) {
	
	    options = options || {};
	
	    // Check if there is a seed and ensure it's an
	    // integer. Otherwise, reset the seed value.
	    if (options.seed && options.seed === parseInt(options.seed, 10)) {
	      seed = options.seed;
	
	    // A string was passed as a seed
	    } else if (typeof options.seed === 'string') {
	      seed = stringToInteger(options.seed);
	
	    // Something was passed as a seed but it wasn't an integer or string
	    } else if (options.seed !== undefined && options.seed !== null) {
	      throw new TypeError('The seed value must be an integer or string');
	
	    // No seed, reset the value outside.
	    } else {
	      seed = null;
	    }
	
	    var H,S,B;
	
	    // Check if we need to generate multiple colors
	    if (options.count !== null && options.count !== undefined) {
	
	      var totalColors = options.count,
	          colors = [];
	
	      options.count = null;
	
	      while (totalColors > colors.length) {
	
	        // Since we're generating multiple colors,
	        // incremement the seed. Otherwise we'd just
	        // generate the same color each time...
	        if (seed && options.seed) options.seed += 1;
	
	        colors.push(randomColor(options));
	      }
	
	      options.count = totalColors;
	
	      return colors;
	    }
	
	    // First we pick a hue (H)
	    H = pickHue(options);
	
	    // Then use H to determine saturation (S)
	    S = pickSaturation(H, options);
	
	    // Then use S and H to determine brightness (B).
	    B = pickBrightness(H, S, options);
	
	    // Then we return the HSB color in the desired format
	    return setFormat([H,S,B], options);
	  };
	
	  function pickHue (options) {
	
	    var hueRange = getHueRange(options.hue),
	        hue = randomWithin(hueRange);
	
	    // Instead of storing red as two seperate ranges,
	    // we group them, using negative numbers
	    if (hue < 0) {hue = 360 + hue;}
	
	    return hue;
	
	  }
	
	  function pickSaturation (hue, options) {
	
	    if (options.luminosity === 'random') {
	      return randomWithin([0,100]);
	    }
	
	    if (options.hue === 'monochrome') {
	      return 0;
	    }
	
	    var saturationRange = getSaturationRange(hue);
	
	    var sMin = saturationRange[0],
	        sMax = saturationRange[1];
	
	    switch (options.luminosity) {
	
	      case 'bright':
	        sMin = 55;
	        break;
	
	      case 'dark':
	        sMin = sMax - 10;
	        break;
	
	      case 'light':
	        sMax = 55;
	        break;
	   }
	
	    return randomWithin([sMin, sMax]);
	
	  }
	
	  function pickBrightness (H, S, options) {
	
	    var bMin = getMinimumBrightness(H, S),
	        bMax = 100;
	
	    switch (options.luminosity) {
	
	      case 'dark':
	        bMax = bMin + 20;
	        break;
	
	      case 'light':
	        bMin = (bMax + bMin)/2;
	        break;
	
	      case 'random':
	        bMin = 0;
	        bMax = 100;
	        break;
	    }
	
	    return randomWithin([bMin, bMax]);
	  }
	
	  function setFormat (hsv, options) {
	
	    switch (options.format) {
	
	      case 'hsvArray':
	        return hsv;
	
	      case 'hslArray':
	        return HSVtoHSL(hsv);
	
	      case 'hsl':
	        var hsl = HSVtoHSL(hsv);
	        return 'hsl('+hsl[0]+', '+hsl[1]+'%, '+hsl[2]+'%)';
	
	      case 'hsla':
	        var hslColor = HSVtoHSL(hsv);
	        return 'hsla('+hslColor[0]+', '+hslColor[1]+'%, '+hslColor[2]+'%, ' + Math.random() + ')';
	
	      case 'rgbArray':
	        return HSVtoRGB(hsv);
	
	      case 'rgb':
	        var rgb = HSVtoRGB(hsv);
	        return 'rgb(' + rgb.join(', ') + ')';
	
	      case 'rgba':
	        var rgbColor = HSVtoRGB(hsv);
	        return 'rgba(' + rgbColor.join(', ') + ', ' + Math.random() + ')';
	
	      default:
	        return HSVtoHex(hsv);
	    }
	
	  }
	
	  function getMinimumBrightness(H, S) {
	
	    var lowerBounds = getColorInfo(H).lowerBounds;
	
	    for (var i = 0; i < lowerBounds.length - 1; i++) {
	
	      var s1 = lowerBounds[i][0],
	          v1 = lowerBounds[i][1];
	
	      var s2 = lowerBounds[i+1][0],
	          v2 = lowerBounds[i+1][1];
	
	      if (S >= s1 && S <= s2) {
	
	         var m = (v2 - v1)/(s2 - s1),
	             b = v1 - m*s1;
	
	         return m*S + b;
	      }
	
	    }
	
	    return 0;
	  }
	
	  function getHueRange (colorInput) {
	
	    if (typeof parseInt(colorInput) === 'number') {
	
	      var number = parseInt(colorInput);
	
	      if (number < 360 && number > 0) {
	        return [number, number];
	      }
	
	    }
	
	    if (typeof colorInput === 'string') {
	
	      if (colorDictionary[colorInput]) {
	        var color = colorDictionary[colorInput];
	        if (color.hueRange) {return color.hueRange;}
	      }
	    }
	
	    return [0,360];
	
	  }
	
	  function getSaturationRange (hue) {
	    return getColorInfo(hue).saturationRange;
	  }
	
	  function getColorInfo (hue) {
	
	    // Maps red colors to make picking hue easier
	    if (hue >= 334 && hue <= 360) {
	      hue-= 360;
	    }
	
	    for (var colorName in colorDictionary) {
	       var color = colorDictionary[colorName];
	       if (color.hueRange &&
	           hue >= color.hueRange[0] &&
	           hue <= color.hueRange[1]) {
	          return colorDictionary[colorName];
	       }
	    } return 'Color not found';
	  }
	
	  function randomWithin (range) {
	    if (seed === null) {
	      return Math.floor(range[0] + Math.random()*(range[1] + 1 - range[0]));
	    } else {
	      //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
	      var max = range[1] || 1;
	      var min = range[0] || 0;
	      seed = (seed * 9301 + 49297) % 233280;
	      var rnd = seed / 233280.0;
	      return Math.floor(min + rnd * (max - min));
	    }
	  }
	
	  function HSVtoHex (hsv){
	
	    var rgb = HSVtoRGB(hsv);
	
	    function componentToHex(c) {
	        var hex = c.toString(16);
	        return hex.length == 1 ? '0' + hex : hex;
	    }
	
	    var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
	
	    return hex;
	
	  }
	
	  function defineColor (name, hueRange, lowerBounds) {
	
	    var sMin = lowerBounds[0][0],
	        sMax = lowerBounds[lowerBounds.length - 1][0],
	
	        bMin = lowerBounds[lowerBounds.length - 1][1],
	        bMax = lowerBounds[0][1];
	
	    colorDictionary[name] = {
	      hueRange: hueRange,
	      lowerBounds: lowerBounds,
	      saturationRange: [sMin, sMax],
	      brightnessRange: [bMin, bMax]
	    };
	
	  }
	
	  function loadColorBounds () {
	
	    defineColor(
	      'monochrome',
	      null,
	      [[0,0],[100,0]]
	    );
	
	    defineColor(
	      'red',
	      [-26,18],
	      [[20,100],[30,92],[40,89],[50,85],[60,78],[70,70],[80,60],[90,55],[100,50]]
	    );
	
	    defineColor(
	      'orange',
	      [19,46],
	      [[20,100],[30,93],[40,88],[50,86],[60,85],[70,70],[100,70]]
	    );
	
	    defineColor(
	      'yellow',
	      [47,62],
	      [[25,100],[40,94],[50,89],[60,86],[70,84],[80,82],[90,80],[100,75]]
	    );
	
	    defineColor(
	      'green',
	      [63,178],
	      [[30,100],[40,90],[50,85],[60,81],[70,74],[80,64],[90,50],[100,40]]
	    );
	
	    defineColor(
	      'blue',
	      [179, 257],
	      [[20,100],[30,86],[40,80],[50,74],[60,60],[70,52],[80,44],[90,39],[100,35]]
	    );
	
	    defineColor(
	      'purple',
	      [258, 282],
	      [[20,100],[30,87],[40,79],[50,70],[60,65],[70,59],[80,52],[90,45],[100,42]]
	    );
	
	    defineColor(
	      'pink',
	      [283, 334],
	      [[20,100],[30,90],[40,86],[60,84],[80,80],[90,75],[100,73]]
	    );
	
	  }
	
	  function HSVtoRGB (hsv) {
	
	    // this doesn't work for the values of 0 and 360
	    // here's the hacky fix
	    var h = hsv[0];
	    if (h === 0) {h = 1;}
	    if (h === 360) {h = 359;}
	
	    // Rebase the h,s,v values
	    h = h/360;
	    var s = hsv[1]/100,
	        v = hsv[2]/100;
	
	    var h_i = Math.floor(h*6),
	      f = h * 6 - h_i,
	      p = v * (1 - s),
	      q = v * (1 - f*s),
	      t = v * (1 - (1 - f)*s),
	      r = 256,
	      g = 256,
	      b = 256;
	
	    switch(h_i) {
	      case 0: r = v; g = t; b = p;  break;
	      case 1: r = q; g = v; b = p;  break;
	      case 2: r = p; g = v; b = t;  break;
	      case 3: r = p; g = q; b = v;  break;
	      case 4: r = t; g = p; b = v;  break;
	      case 5: r = v; g = p; b = q;  break;
	    }
	
	    var result = [Math.floor(r*255), Math.floor(g*255), Math.floor(b*255)];
	    return result;
	  }
	
	  function HSVtoHSL (hsv) {
	    var h = hsv[0],
	      s = hsv[1]/100,
	      v = hsv[2]/100,
	      k = (2-s)*v;
	
	    return [
	      h,
	      Math.round(s*v / (k<1 ? k : 2-k) * 10000) / 100,
	      k/2 * 100
	    ];
	  }
	
	  function stringToInteger (string) {
	    var total = 0
	    for (var i = 0; i !== string.length; i++) {
	      if (total >= Number.MAX_SAFE_INTEGER) break;
	      total += string.charCodeAt(i)
	    }
	    return total
	  }
	
	  return randomColor;
	}));


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	var _randomcolor = __webpack_require__(2);
	
	var _randomcolor2 = _interopRequireDefault(_randomcolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var vertexShader = '\n    \n    precision mediump float;\n\n    varying vec2 vUv;\n       \n    void main() {\n        vUv = uv;\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n    }\n    \n';
	
	var fragmentShader = '\n    \n    precision mediump float;\n\n    uniform float time;\n\n    uniform sampler2D imageTop;\n    uniform sampler2D imageBottom;\n\n    uniform sampler2D imageRight;\n    uniform sampler2D imageLeft;\n\n    uniform vec3 color;\n    \n    varying vec2 vUv;\n\n    float cheapLuma ( vec3 rgb ) {\n        return ( rgb.r + rgb.r + rgb.b + rgb.g + rgb.g + rgb.g ) / 6.0;\n    }\n\n    void main () {\n\n        vec4 pixelTop = texture2D(imageTop, vUv);\n        float lTop = cheapLuma( pixelTop.rgb );\n        \n        vec4 pixelBottom = texture2D(imageBottom, vUv);\n        float lBottom = cheapLuma( pixelBottom.rgb );\n\n        vec4 pixelRight = texture2D(imageRight, vUv);\n        float lRight = cheapLuma( pixelRight.rgb );\n        \n        vec4 pixelLeft = texture2D(imageLeft, vUv);\n        float lLeft = cheapLuma( pixelLeft.rgb );\n\n        float distX = (1.0-lLeft + lRight)/2.0; \n        float distY = (1.0-lBottom + lTop)/2.0; \n        gl_FragColor = vec4( distX, distY, 1.0, 1.0 );\n    }\n\n';
	
	var RTT = function () {
	    function RTT(width, height, mousePosition) {
	        _classCallCheck(this, RTT);
	
	        this.loader = new _three2.default.TextureLoader();
	
	        this.lifetime = 0;
	
	        this.camera = new _three2.default.OrthographicCamera(width / -2, width / 2, height / 2, height / -2, -10000, 10000);
	
	        this.scene = new _three2.default.Scene();
	
	        this.texture = new _three2.default.WebGLRenderTarget(window.innerWidth, window.innerHeight, {
	            minFilter: _three2.default.LinearFilter,
	            magFilter: _three2.default.LinearFilter,
	            format: _three2.default.RGBFormat
	        });
	
	        var geometry = new _three2.default.PlaneBufferGeometry(width, height);
	        var material = new _three2.default.ShaderMaterial({
	            uniforms: {
	                imageTop: { type: "t", value: this.loader.load('img/top-512.png') },
	                imageBottom: { type: "t", value: this.loader.load('img/bottom-512.png') },
	                imageRight: { type: "t", value: this.loader.load('img/right-512.png') },
	                imageLeft: { type: "t", value: this.loader.load('img/left-512.png') },
	                // imageTop    : { type: "t",  value:  this.loader.load('img/paper-top-512.png') },
	                // imageBottom : { type: "t",  value:  this.loader.load('img/paper-bottom-512.png') },
	                // imageRight  : { type: "t",  value:  this.loader.load('img/paper-right-512.png') },
	                // imageLeft   : { type: "t",  value:  this.loader.load('img/paper-left-512.png') },
	                lightPos: { type: "2f", value: mousePosition },
	                time: { type: "f", value: 0 },
	                color: { type: "c", value: new _three2.default.Color((0, _randomcolor2.default)()) }
	            },
	            vertexShader: vertexShader,
	            fragmentShader: fragmentShader,
	            blending: _three2.default.AdditiveBlending
	        });
	
	        this.quad = new _three2.default.Mesh(geometry, material);
	        this.scene.add(this.quad);
	    }
	
	    _createClass(RTT, [{
	        key: 'render',
	        value: function render(renderer, delta) {
	
	            this.lifetime += delta * 3;
	
	            this.quad.material.uniforms.time.value = this.lifetime;
	
	            renderer.render(this.scene, this.camera, this.texture, true);
	        }
	    }]);
	
	    return RTT;
	}();
	
	exports.default = RTT;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	var _randomcolor = __webpack_require__(2);
	
	var _randomcolor2 = _interopRequireDefault(_randomcolor);
	
	var _RTT = __webpack_require__(4);
	
	var _RTT2 = _interopRequireDefault(_RTT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var frameSize = { x: 512, y: 512 };
	
	var vertexShader = '\n    \n    precision mediump float;\n\n    varying vec2 vUv;\n       \n    void main() {\n        vUv = uv;\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n    }\n    \n';
	
	var fragmentShader = '\n    \n    precision mediump float;\n\n    uniform float time;\n\n    uniform sampler2D imageTop;\n    uniform sampler2D imageBottom;\n\n    uniform sampler2D imageRight;\n    uniform sampler2D imageLeft;\n\n    uniform vec3 color;\n    \n    varying vec2 vUv;\n\n    float cheapLuma ( vec3 rgb ) {\n        return ( rgb.r + rgb.r + rgb.b + rgb.g + rgb.g + rgb.g ) / 6.0;\n    }\n\n    void main () {\n\n        vec4 pixelTop = texture2D(imageTop, vUv);\n        float lTop = cheapLuma( pixelTop.rgb );\n        \n        vec4 pixelBottom = texture2D(imageBottom, vUv);\n        float lBottom = cheapLuma( pixelBottom.rgb );\n\n        vec4 pixelRight = texture2D(imageRight, vUv);\n        float lRight = cheapLuma( pixelRight.rgb );\n        \n        vec4 pixelLeft = texture2D(imageLeft, vUv);\n        float lLeft = cheapLuma( pixelLeft.rgb );\n\n        gl_FragColor = vec4( lRight - lLeft, 0.0, lTop - lBottom, 1.0 );\n\n        // gl_FragColor = vec4( color.rgb * abs(sin(vUv.x * 100.0)) * abs(sin(vUv.y * 100.0 + time*4.0)), 1.0);\n    }\n\n';
	
	var Step01 = function () {
	    function Step01() {
	        _classCallCheck(this, Step01);
	
	        this.loader = new _three2.default.TextureLoader();
	
	        this.mousePosition = new _three2.default.Vector2();
	
	        this.clock = new _three2.default.Clock();
	        this.scene = new _three2.default.Scene();
	
	        this.camera = new _three2.default.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
	        this.camera.position.z = 1000;
	
	        this.renderer = new _three2.default.WebGLRenderer({ alpha: true });
	        this.renderer.setSize(window.innerWidth, window.innerHeight);
	        this.renderer.setClearColor(0x000000, 0);
	
	        document.body.appendChild(this.renderer.domElement);
	
	        this.rtt = new _RTT2.default(512, 512, this.mousePosition);
	
	        this.mesh = this.newMesh();
	        this.scene.add(this.mesh);
	
	        var ambientLight = new _three2.default.AmbientLight(0x777777);
	        this.scene.add(ambientLight);
	
	        this.light = new _three2.default.PointLight(0x777777, 1.0, 5000);
	        this.scene.add(this.light);
	        this.light.position.z = this.camera.position.y;
	
	        document.addEventListener('mousemove', this.onMouseMove.bind(this), false);
	        // window.addEventListener( 'resize', this.onWindowResize.bind(this), false );
	
	        this.onWindowResize();
	        this.onMouseMove({ clientX: window.innerWidth / 2, clientY: window.innerHeight / 2 });
	        this.animate();
	    }
	
	    _createClass(Step01, [{
	        key: 'onMouseMove',
	        value: function onMouseMove(event) {
	
	            this.mousePosition.x = ((event.clientX + document.body.scrollLeft) / window.innerWidth - .5) * 2;
	            this.mousePosition.y = -((event.clientY + document.body.scrollTop) / window.innerHeight - .5) * 2;
	            this.light.position.x = window.innerWidth / 2 * this.mousePosition.x;
	            this.light.position.y = window.innerHeight / 2 * this.mousePosition.y;
	            this.light.position.z = this.camera.position.z / 2;
	        }
	    }, {
	        key: 'onWindowResize',
	        value: function onWindowResize() {
	
	            this.camera.aspect = window.innerWidth / window.innerHeight;
	            this.camera.updateProjectionMatrix();
	
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	
	            var scaleWidth = window.innerWidth / frameSize.x;
	            var scaleHeight = window.innerHeight / frameSize.y;
	
	            if (scaleWidth < scaleHeight) this.camera.position.z = frameSize.x / this.camera.aspect / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));else this.camera.position.z = frameSize.y / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));
	        }
	    }, {
	        key: 'newMesh',
	        value: function newMesh() {
	
	            this.paperTexture = this.loader.load('img/center-512.png');
	
	            var geometry = new _three2.default.PlaneBufferGeometry(frameSize.x, frameSize.y);
	            var material = new _three2.default.MeshPhongMaterial({
	                // color: 0xffffff,
	                map: this.paperTexture,
	                shininess: 1,
	                specular: 0xBBBBBB,
	                specularMap: this.rtt.texture.texture,
	                normalMap: this.rtt.texture.texture,
	                normalScale: new _three2.default.Vector2(1, 1),
	                side: _three2.default.DoubleSide
	            });
	
	            return new _three2.default.Mesh(geometry, material);
	        }
	    }, {
	        key: 'animate',
	        value: function animate() {
	
	            requestAnimationFrame(this.animate.bind(this));
	
	            this.rtt.render(this.renderer, this.clock.getDelta());
	
	            this.renderer.render(this.scene, this.camera);
	        }
	    }]);
	
	    return Step01;
	}();
	
	exports.default = Step01;
	;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	var _randomcolor = __webpack_require__(2);
	
	var _randomcolor2 = _interopRequireDefault(_randomcolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var vertexShader = '\n    \n    precision mediump float;\n\n    varying vec2 vUv;\n       \n    void main() {\n        vUv = uv;\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n    }\n    \n';
	
	var fragmentShader = '\n    \n    precision mediump float;\n\n    uniform float time;\n\n    uniform sampler2D imageTop;\n    uniform sampler2D imageBottom;\n\n    uniform sampler2D imageRight;\n    uniform sampler2D imageLeft;\n\n    uniform vec3 color;\n    \n    varying vec2 vUv;\n\n    float cheapLuma ( vec3 rgb ) {\n        return ( rgb.r + rgb.r + rgb.b + rgb.g + rgb.g + rgb.g ) / 6.0;\n    }\n\n    void main () {\n\n        vec4 pixelTop = texture2D(imageTop, vUv);\n        float lTop = cheapLuma( pixelTop.rgb );\n        \n        vec4 pixelBottom = texture2D(imageBottom, vUv);\n        float lBottom = cheapLuma( pixelBottom.rgb );\n\n        vec4 pixelRight = texture2D(imageRight, vUv);\n        float lRight = cheapLuma( pixelRight.rgb );\n        \n        vec4 pixelLeft = texture2D(imageLeft, vUv);\n        float lLeft = cheapLuma( pixelLeft.rgb );\n\n        float distX = (1.0-lLeft + lRight)/2.0; \n        float distY = (1.0-lBottom + lTop)/2.0; \n        gl_FragColor = vec4( distX, distY, 1.0, 1.0 );\n    }\n\n';
	
	var RTT = function () {
	    function RTT(width, height, mousePosition) {
	        _classCallCheck(this, RTT);
	
	        this.loader = new _three2.default.TextureLoader();
	
	        this.lifetime = 0;
	
	        this.camera = new _three2.default.OrthographicCamera(width / -2, width / 2, height / 2, height / -2, -10000, 10000);
	
	        this.scene = new _three2.default.Scene();
	
	        this.texture = new _three2.default.WebGLRenderTarget(window.innerWidth, window.innerHeight, {
	            minFilter: _three2.default.LinearFilter,
	            magFilter: _three2.default.LinearFilter,
	            format: _three2.default.RGBFormat
	        });
	
	        var geometry = new _three2.default.PlaneBufferGeometry(width, height);
	        var material = new _three2.default.ShaderMaterial({
	            uniforms: {
	                // imageTop    : { type: "t",  value:  this.loader.load('img/top-512.png') },
	                // imageBottom : { type: "t",  value:  this.loader.load('img/bottom-512.png') },
	                // imageRight  : { type: "t",  value:  this.loader.load('img/right-512.png') },
	                // imageLeft   : { type: "t",  value:  this.loader.load('img/left-512.png') },
	                imageTop: { type: "t", value: this.loader.load('img/paper-top-512.png') },
	                imageBottom: { type: "t", value: this.loader.load('img/paper-bottom-512.png') },
	                imageRight: { type: "t", value: this.loader.load('img/paper-right-512.png') },
	                imageLeft: { type: "t", value: this.loader.load('img/paper-left-512.png') },
	                lightPos: { type: "2f", value: mousePosition },
	                time: { type: "f", value: 0 },
	                color: { type: "c", value: new _three2.default.Color((0, _randomcolor2.default)()) }
	            },
	            vertexShader: vertexShader,
	            fragmentShader: fragmentShader,
	            blending: _three2.default.AdditiveBlending
	        });
	
	        this.quad = new _three2.default.Mesh(geometry, material);
	        this.scene.add(this.quad);
	    }
	
	    _createClass(RTT, [{
	        key: 'render',
	        value: function render(renderer, delta) {
	
	            this.lifetime += delta * 3;
	
	            this.quad.material.uniforms.time.value = this.lifetime;
	
	            renderer.render(this.scene, this.camera, this.texture, true);
	        }
	    }]);
	
	    return RTT;
	}();
	
	exports.default = RTT;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// import Stats from '../../../../node_modules/three/examples/js/libs/stats.min.js';
	// import * as dat from 'libs/utils/dat.gui.min';
	
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	var _randomcolor = __webpack_require__(2);
	
	var _randomcolor2 = _interopRequireDefault(_randomcolor);
	
	var _RTT = __webpack_require__(6);
	
	var _RTT2 = _interopRequireDefault(_RTT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var frameSize = { x: 512, y: 512 };
	
	var vertexShader = '\n    \n    precision mediump float;\n\n    varying vec2 vUv;\n       \n    void main() {\n        vUv = uv;\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n    }\n    \n';
	
	var fragmentShader = '\n    \n    precision mediump float;\n\n    uniform float time;\n\n    uniform sampler2D imageTop;\n    uniform sampler2D imageBottom;\n\n    uniform sampler2D imageRight;\n    uniform sampler2D imageLeft;\n\n    uniform vec3 color;\n    \n    varying vec2 vUv;\n\n    float cheapLuma ( vec3 rgb ) {\n        return ( rgb.r + rgb.r + rgb.b + rgb.g + rgb.g + rgb.g ) / 6.0;\n    }\n\n    void main () {\n\n        vec4 pixelTop = texture2D(imageTop, vUv);\n        float lTop = cheapLuma( pixelTop.rgb );\n        \n        vec4 pixelBottom = texture2D(imageBottom, vUv);\n        float lBottom = cheapLuma( pixelBottom.rgb );\n\n        vec4 pixelRight = texture2D(imageRight, vUv);\n        float lRight = cheapLuma( pixelRight.rgb );\n        \n        vec4 pixelLeft = texture2D(imageLeft, vUv);\n        float lLeft = cheapLuma( pixelLeft.rgb );\n\n        gl_FragColor = vec4( lRight - lLeft, 0.0, lTop - lBottom, 1.0 );\n\n        // gl_FragColor = vec4( color.rgb * abs(sin(vUv.x * 100.0)) * abs(sin(vUv.y * 100.0 + time*4.0)), 1.0);\n    }\n\n';
	
	var Step02 = function () {
	    function Step02() {
	        _classCallCheck(this, Step02);
	
	        this.loader = new _three2.default.TextureLoader();
	
	        this.mousePosition = new _three2.default.Vector2();
	
	        this.clock = new _three2.default.Clock();
	        this.scene = new _three2.default.Scene();
	
	        this.camera = new _three2.default.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
	        this.camera.position.z = 1000;
	
	        this.renderer = new _three2.default.WebGLRenderer({ alpha: true });
	        this.renderer.setSize(window.innerWidth, window.innerHeight);
	        this.renderer.setClearColor(0x000000, 0);
	
	        document.body.appendChild(this.renderer.domElement);
	
	        this.rtt = new _RTT2.default(512, 512, this.mousePosition);
	        // this.rtt.render( this.renderer, this.clock.getDelta());
	
	        this.mesh = this.newMesh();
	        this.scene.add(this.mesh);
	
	        // let ambientLight = new THREE.AmbientLight( 0x888888 );
	        var ambientLight = new _three2.default.AmbientLight(0x777777);
	        this.scene.add(ambientLight);
	
	        this.light = new _three2.default.PointLight(0x777777, 1.0, 5000);
	        this.scene.add(this.light);
	        this.light.position.z = this.camera.position.y;
	
	        document.addEventListener('mousemove', this.onMouseMove.bind(this), false);
	        // window.addEventListener( 'resize', this.onWindowResize.bind(this), false );
	
	        this.onWindowResize();
	        this.onMouseMove({ clientX: window.innerWidth / 2, clientY: window.innerHeight / 2 });
	        this.animate();
	    }
	
	    _createClass(Step02, [{
	        key: 'onMouseMove',
	        value: function onMouseMove(event) {
	
	            this.mousePosition.x = ((event.clientX + document.body.scrollLeft) / window.innerWidth - .5) * 2;
	            this.mousePosition.y = -((event.clientY + document.body.scrollTop) / window.innerHeight - .5) * 2;
	            this.light.position.x = window.innerWidth / 2 * this.mousePosition.x;
	            this.light.position.y = window.innerHeight / 2 * this.mousePosition.y;
	            this.light.position.z = this.camera.position.z / 2;
	        }
	    }, {
	        key: 'onWindowResize',
	        value: function onWindowResize() {
	
	            this.camera.aspect = window.innerWidth / window.innerHeight;
	            this.camera.updateProjectionMatrix();
	
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	
	            var scaleWidth = window.innerWidth / frameSize.x;
	            var scaleHeight = window.innerHeight / frameSize.y;
	
	            if (scaleWidth < scaleHeight) this.camera.position.z = frameSize.x / this.camera.aspect / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));else this.camera.position.z = frameSize.y / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));
	        }
	    }, {
	        key: 'newMesh',
	        value: function newMesh() {
	
	            this.paperTexture = this.loader.load('img/paper-center-512.png');
	
	            // let geometry = new THREE.SphereGeometry( 200, 60, 60);
	            var geometry = new _three2.default.PlaneBufferGeometry(frameSize.x, frameSize.y);
	            var material = new _three2.default.MeshPhongMaterial({
	                // color: 0xffffff,
	                // color: 0x777777,
	                // color: 0,
	                // map: this.loader.load('img/center-512.png'),
	                map: this.paperTexture,
	                shininess: 1,
	                specular: 0x666666,
	                specularMap: this.rtt.texture.texture,
	                normalMap: this.rtt.texture.texture,
	                normalScale: new _three2.default.Vector2(1, 1),
	                side: _three2.default.DoubleSide
	            });
	
	            return new _three2.default.Mesh(geometry, material);
	        }
	    }, {
	        key: 'animate',
	        value: function animate() {
	
	            requestAnimationFrame(this.animate.bind(this));
	
	            this.rtt.render(this.renderer, this.clock.getDelta());
	
	            this.renderer.render(this.scene, this.camera);
	        }
	    }]);
	
	    return Step02;
	}();
	
	exports.default = Step02;
	;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var vertexShader = '\n    \n    precision mediump float;\n\n    varying vec2 vUv;\n       \n    void main() {\n        vUv = uv;\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n    }\n    \n';
	
	var fragmentShader = '\n    \n    precision mediump float;\n\n    uniform float time;\n\n    uniform sampler2D imageTop;\n    uniform sampler2D imageBottom;\n\n    uniform sampler2D imageRight;\n    uniform sampler2D imageLeft;\n\n    uniform vec3 color;\n    \n    varying vec2 vUv;\n\n    float cheapLuma ( vec3 rgb ) {\n        return ( rgb.r + rgb.r + rgb.b + rgb.g + rgb.g + rgb.g ) / 6.0;\n    }\n\n    void main () {\n\n        vec4 pixelTop = texture2D(imageTop, vUv);\n        float lTop = cheapLuma( pixelTop.rgb );\n        \n        vec4 pixelBottom = texture2D(imageBottom, vUv);\n        float lBottom = cheapLuma( pixelBottom.rgb );\n\n        vec4 pixelRight = texture2D(imageRight, vUv);\n        float lRight = cheapLuma( pixelRight.rgb );\n        \n        vec4 pixelLeft = texture2D(imageLeft, vUv);\n        float lLeft = cheapLuma( pixelLeft.rgb );\n\n        float distX = (1.0-lLeft + lRight)/2.0; \n        float distY = (1.0-lBottom + lTop)/2.0; \n        gl_FragColor = vec4( distX, distY, 1.0, 1.0 );\n    }\n\n';
	
	var RTT = function () {
	    function RTT(width, height, mousePosition) {
	        _classCallCheck(this, RTT);
	
	        this.loader = new _three2.default.TextureLoader();
	
	        this.lifetime = 0;
	
	        this.camera = new _three2.default.OrthographicCamera(width / -2, width / 2, height / 2, height / -2, -10000, 10000);
	
	        this.scene = new _three2.default.Scene();
	
	        this.texture = new _three2.default.WebGLRenderTarget(window.innerWidth, window.innerHeight, {
	            minFilter: _three2.default.LinearFilter,
	            magFilter: _three2.default.LinearFilter,
	            format: _three2.default.RGBFormat
	        });
	
	        var geometry = new _three2.default.PlaneBufferGeometry(width, height);
	        var material = new _three2.default.ShaderMaterial({
	            uniforms: {
	                // imageTop    : { type: "t",  value:  this.loader.load('img/top-512.png') },
	                // imageBottom : { type: "t",  value:  this.loader.load('img/bottom-512.png') },
	                // imageRight  : { type: "t",  value:  this.loader.load('img/right-512.png') },
	                // imageLeft   : { type: "t",  value:  this.loader.load('img/left-512.png') },
	                // imageTop    : { type: "t",  value:  this.loader.load('img/colors-top-1024.png') },
	                // imageBottom : { type: "t",  value:  this.loader.load('img/colors-bottom-1024.png') },
	                // imageRight  : { type: "t",  value:  this.loader.load('img/colors-right-1024.png') },
	                // imageLeft   : { type: "t",  value:  this.loader.load('img/colors-left-1024.png') },
	                imageTop: { type: "t", value: this.loader.load('img/colors-top-512.png') },
	                imageBottom: { type: "t", value: this.loader.load('img/colors-bottom-512.png') },
	                imageRight: { type: "t", value: this.loader.load('img/colors-right-512.png') },
	                imageLeft: { type: "t", value: this.loader.load('img/colors-left-512.png') },
	                lightPos: { type: "2f", value: mousePosition },
	                time: { type: "f", value: 0 }
	            },
	            vertexShader: vertexShader,
	            fragmentShader: fragmentShader,
	            blending: _three2.default.AdditiveBlending
	        });
	
	        this.quad = new _three2.default.Mesh(geometry, material);
	        this.scene.add(this.quad);
	    }
	
	    _createClass(RTT, [{
	        key: 'render',
	        value: function render(renderer, delta) {
	
	            this.lifetime += delta * 3;
	
	            this.quad.material.uniforms.time.value = this.lifetime;
	
	            renderer.render(this.scene, this.camera, this.texture, true);
	        }
	    }]);
	
	    return RTT;
	}();
	
	exports.default = RTT;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _three = __webpack_require__(1);
	
	var _three2 = _interopRequireDefault(_three);
	
	var _RTT = __webpack_require__(8);
	
	var _RTT2 = _interopRequireDefault(_RTT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var frameSize = { x: 512, y: 512 };
	
	var Step03 = function () {
	    function Step03() {
	        _classCallCheck(this, Step03);
	
	        this.loader = new _three2.default.TextureLoader();
	
	        this.mousePosition = new _three2.default.Vector2();
	
	        this.clock = new _three2.default.Clock();
	        this.scene = new _three2.default.Scene();
	
	        this.camera = new _three2.default.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
	        this.camera.position.z = 1000;
	
	        this.renderer = new _three2.default.WebGLRenderer({ alpha: true });
	        this.renderer.setSize(window.innerWidth, window.innerHeight);
	        this.renderer.setClearColor(0x000000, 0);
	
	        document.body.appendChild(this.renderer.domElement);
	
	        this.rtt = new _RTT2.default(512, 512, this.mousePosition);
	        // this.rtt.render( this.renderer, this.clock.getDelta());
	
	        this.mesh = this.newMesh();
	        this.scene.add(this.mesh);
	
	        // let ambientLight = new THREE.AmbientLight( 0x888888 );
	        var ambientLight = new _three2.default.AmbientLight(0xcccccc);
	        this.scene.add(ambientLight);
	
	        this.light = new _three2.default.PointLight(0x777777, 0.7, 2500);
	        this.scene.add(this.light);
	        this.light.position.z = 1500;
	
	        document.addEventListener('mousemove', this.onMouseMove.bind(this), false);
	        window.addEventListener('resize', this.onWindowResize.bind(this), false);
	
	        this.onWindowResize();
	        this.onMouseMove({ clientX: window.innerWidth / 2, clientY: window.innerHeight / 2 });
	        this.animate();
	    }
	
	    _createClass(Step03, [{
	        key: 'onMouseMove',
	        value: function onMouseMove(event) {
	
	            this.mousePosition.x = ((event.clientX + document.body.scrollLeft) / window.innerWidth - .5) * 2;
	            this.mousePosition.y = -((event.clientY + document.body.scrollTop) / window.innerHeight - .5) * 2;
	            this.light.position.x = window.innerWidth / 2 * this.mousePosition.x;
	            this.light.position.y = window.innerHeight / 2 * this.mousePosition.y;
	            this.light.position.z = this.camera.position.z / 2;
	        }
	    }, {
	        key: 'onWindowResize',
	        value: function onWindowResize() {
	
	            this.camera.aspect = window.innerWidth / window.innerHeight;
	            this.camera.updateProjectionMatrix();
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	
	            var scaleWidth = window.innerWidth / frameSize.x;
	            var scaleHeight = window.innerHeight / frameSize.y;
	
	            if (scaleWidth < scaleHeight) this.camera.position.z = frameSize.x / this.camera.aspect / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));else this.camera.position.z = frameSize.y / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));
	        }
	    }, {
	        key: 'newMesh',
	        value: function newMesh() {
	
	            this.paperTexture = this.loader.load('img/colors-center-512-neon-2.png');
	
	            var geometry = new _three2.default.PlaneBufferGeometry(frameSize.x, frameSize.y);
	            var material = new _three2.default.MeshPhongMaterial({
	                map: this.paperTexture,
	                shininess: 5,
	                specular: 0x222222,
	                specularMap: this.rtt.texture.texture,
	                normalMap: this.rtt.texture.texture,
	                normalScale: new _three2.default.Vector2(1, 1),
	                side: _three2.default.DoubleSide
	            });
	
	            return new _three2.default.Mesh(geometry, material);
	        }
	    }, {
	        key: 'animate',
	        value: function animate() {
	
	            requestAnimationFrame(this.animate.bind(this));
	
	            this.rtt.render(this.renderer, this.clock.getDelta());
	
	            this.renderer.render(this.scene, this.camera);
	        }
	    }]);
	
	    return Step03;
	}();
	
	exports.default = Step03;
	;

/***/ })
]);


// WEBPACK FOOTER //
// js/app.bundle.js